import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a35e1cc43fe9919b8a5dc85c38a292a19b from "./generated-4997caf2-8afe-4cb8-8b4a-36640c5494bb.json";

import a102c5b69cae00368ae97db89e0db43bdb from "./generated-ff2700bd-72e4-469b-b44a-a849b20af7e3.json";

import a45eed897d854061ab40481374fbabf0cb from "./generated-ee36eba7-1c30-4cb9-9d7b-9806574a4d27.json";

import a54802c4d2bb23949db2b0d76ef4d515ab from "./generated-3c771d7c-36b6-46db-8462-acba5d372eb9.json";

import afbd66e547926de48d5b656fe372c1198b from "./generated-f4af3d62-50ce-4135-9c0c-1d3998fe2cca.json";

import abb2215a5f64ea46a03e624c67a0e702ab from "./generated-dc6f6e29-19f7-4ad5-9343-d8afcfa8bd52.json";

import af96fa284609016d9941ccad05f2f4e88b from "./generated-fb9971b2-d3cf-4cf0-a289-a58888fd15d0.json";

import a1b1160557000a5eebd0032e29169a9dbb from "./generated-b7def3cd-4f3b-4042-af2c-ca567ef03f91.json";

import a6018996708bd84ab349d07f2ade6dc1db from "./generated-f36da4f2-64c3-452f-99a2-e70c751dfeab.json";

import ae1be05f394671e1e9eae667358c1ba96b from "./generated-827e2f0d-9355-4ed7-b594-492ffa862560.json";

import a65b9749e56412cb452f430b697600ff1b from "./generated-4f763f63-af39-4f2d-8614-2eea4804019b.json";

import a3bc7f63f85a8c404ce93065c86360dbdb from "./generated-34db8e5f-1bdd-45f0-9ca3-a14e728cab69.json";

import ac1fd90d6c3b788f5a2f80a9e61476601b from "./generated-434bde36-a212-411f-ba35-4fc6484c1396.json";

import a69744dbca406d2ec823e99d17e88bf1cb from "./generated-52437e03-49a5-4672-9982-ec9707495081.json";

import a80f05f1e8e1b675abf515f2587979f29b from "./generated-18440cd7-70d8-4442-ba6b-fafb5938864d.json";

import a201da24457acb4f425913273213a5c87b from "./generated-6fa8808c-2194-4480-8845-32f8d3036d9d.json";

import ac86e57350fad55be6a485a2243f3a750b from "./generated-5be03e55-343c-4387-ab46-1ea36ec72cce.json";

import abf798af43f96e34e9fb9c4f26278cef9b from "./generated-ba53c82f-a32b-4cb3-a504-4ce97e917f97.json";

import ae5f3625228ae7b86a46467f5110ce42eb from "./generated-9f5434a5-5b39-49d4-a715-7f8d283f5f0d.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a35e1cc43fe9919b8a5dc85c38a292a19b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a102c5b69cae00368ae97db89e0db43bdb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a45eed897d854061ab40481374fbabf0cb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a54802c4d2bb23949db2b0d76ef4d515ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(afbd66e547926de48d5b656fe372c1198b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(abb2215a5f64ea46a03e624c67a0e702ab);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(af96fa284609016d9941ccad05f2f4e88b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a1b1160557000a5eebd0032e29169a9dbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a6018996708bd84ab349d07f2ade6dc1db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ae1be05f394671e1e9eae667358c1ba96b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a65b9749e56412cb452f430b697600ff1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a3bc7f63f85a8c404ce93065c86360dbdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac1fd90d6c3b788f5a2f80a9e61476601b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a69744dbca406d2ec823e99d17e88bf1cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a80f05f1e8e1b675abf515f2587979f29b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a201da24457acb4f425913273213a5c87b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ac86e57350fad55be6a485a2243f3a750b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(abf798af43f96e34e9fb9c4f26278cef9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ae5f3625228ae7b86a46467f5110ce42eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ac86e57350fad55be6a485a2243f3a750b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */